import React from 'react';
import { colors } from '@cimpress/react-components';

const colorBlockStyles = {
  padding: '20px',
  height: '70px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const ColorDemo = () => {
  const colorStack = (color, name, textColor = 'white') => (
    <div style={{ color: textColor, margin: '0 5px' }}>
      <div style={{ ...colorBlockStyles, background: color.base }}>{name}.base</div>
      <div style={{ ...colorBlockStyles, background: color.darker }}>{name}.darker</div>
      <div style={{ ...colorBlockStyles, background: color.darkest }}>{name}.darkest</div>
    </div>
  );
  const colorBlock = (color, name, textColor = 'white') => (
    <div style={{ ...colorBlockStyles, color: textColor, margin: '0 5px', background: color }}>{name}</div>
  );

  const remarks = (
    <div>
      <p>The colors of the styleguide are available as utility constants.</p>
      <p>
        All colors are exported from @cimpress/react-component as <code>colors</code>. Colors with interaction stacks
        are stored as objects, greyscale variants are stored as plain strings.
      </p>
      <p>
        You generally should not need to use these, but there may be cases where an application-specific piece of UI
        needs to be colored.
      </p>
    </div>
  );

  return (
    <div style={{ paddingBottom: '30px' }}>
      <h2>Colors</h2>
      {remarks}
      <h4>Brand Primary</h4>
      <div style={{ display: 'flex' }}>
        {colorStack(colors.persimmon, 'persimmon')}
        {colorStack(colors.cobalt, 'cobalt')}
      </div>
      <h4>Greyscale</h4>
      <div style={{ display: 'flex' }}>
        {colorBlock(colors.coal, 'coal')}
        {colorBlock(colors.shale, 'shale')}
        {colorBlock(colors.slate, 'slate')}
        {colorBlock(colors.alloy, 'alloy', colors.coal)}
        {colorBlock(colors.platinum, 'platinum', colors.coal)}
        {colorBlock(colors.silver, 'silver', colors.coal)}
        {colorBlock(colors.horizon, 'horizon', colors.coal)}
        {colorBlock(colors.white, 'white', colors.coal)}
      </div>
      <h4>Interaction</h4>
      <div style={{ display: 'flex' }}>
        {colorStack(colors.ocean, 'ocean')}
        {colorStack(colors.teal, 'teal')}
        {colorStack(colors.sky, 'sky')}
        {colorStack(colors.granite, 'granite')}
      </div>
      <h4>Messaging</h4>
      <div style={{ display: 'flex' }}>
        {colorStack(colors.info, 'info')}
        {colorStack(colors.success, 'success')}
        {colorStack(colors.warning, 'warning')}
        {colorStack(colors.danger, 'danger')}
      </div>
    </div>
  );
};

export default ColorDemo;
